<template>
	<el-form ref="form" :model="user" style="margin-left: 35%; width: 30%; margin-top: 10%;">
		<div class="title"> Silver </div>
		<el-form-item style="margin-top: 40px" prop="username">
			<el-input v-model="user.username" prefix-icon="User" placeholder="请输入用户名"/>
		</el-form-item>
		<el-form-item prop="password">
			<el-input type="password" v-model="user.password" prefix-icon="Lock" placeholder="请输入密码" show-password/>
		</el-form-item>
		<el-form-item>
			<el-button type="primary" @click="login">登录</el-button>
		</el-form-item>
	</el-form>
</template>

<script>
import axios from '@/utils/axios';
import md5 from 'js-md5';
import {user} from '@/utils/index';

export default {
	name: 'login-index',
	methods: {
		async login() {
			let password = md5(user.password);
			let res = await axios.post(`/user/login`, {username: user.username, password});
			if (!res.err) {
				user.saveToken(res.msg.token, axios);
				user.saveStatus(res.msg.status);
				user.saveTimeZone(res.msg.time_zone_offset);
				location.reload();
			} else {
				if (user.token) user.saveToken('', axios);
				this.$router.push({name: 'stats_home'});
			}
		},
		async test() {
			await axios.post(`/user/test`, {});
		}
	},
	data() {
		return {user}; 
	}
}
</script>